export default __webpack_public_path__ + "static/media/bean-character.0879491b.webp";